import { Component } from 'react';
import { withSnackbar } from 'notistack';
import { autorun } from 'mobx';
import {inject, observer} from "mobx-react";

@inject('LayoutStore')
@observer
class Notifier extends Component {
    displayed = [];

    storeDisplayed = (id) => {
        this.displayed = [...this.displayed, id];
    };

    componentDidMount() {
        autorun(() => {
            const { notifications = [] } = this.props.LayoutStore;
            notifications.forEach((notification) => {
                console.log("notif", notification.message, notification.options);
                // Do nothing if snackbar is already displayed
                if (this.displayed.includes(notification.key)) return;
                // Display snackbar using notistack
                this.props.enqueueSnackbar(notification.message, notification.options);
                // Keep track of snackbars that we've displayed
                this.storeDisplayed(notification.key);
                // Dispatch action to remove snackbar from mobx store
                this.props.LayoutStore.removeSnackbar(notification.key);
            });
        });
    }

    render() {
        return null;
    }
}

export default withSnackbar(Notifier);
